export default function TwoFactorTab() {
  return (
    <div className="wc-card wc-elev-sm" style={{ gap: 18 }}>
      <div>
        <h3 className="wc-card-title" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
          </svg>
          Zwei-Faktor-Authentifizierung
        </h3>
        <p className="wc-muted" style={{ fontSize: 13, margin: '4px 0 0' }}>
          Erhöhen Sie die Sicherheit Ihres Kontos mit einem zweiten Faktor
        </p>
      </div>

      <div className="wc-alert wc-alert-info" style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <span style={{ fontWeight: 500 }}>Feature in Entwicklung</span>
        <span style={{ display: 'none' }} />
      </div>
      <p className="wc-card-body" style={{ margin: 0 }}>
        Die Zwei-Faktor-Authentifizierung wird derzeit für die Portal-App entwickelt. Dieses Feature ermöglicht es
        Ihnen, Ihr Konto mit einem zusätzlichen Sicherheitsfaktor zu schützen.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13 }}>
        <p style={{ margin: 0, fontWeight: 500 }}>Was ist 2FA?</p>
        <p className="wc-muted" style={{ margin: 0 }}>
          Die Zwei-Faktor-Authentifizierung (2FA) fügt eine zusätzliche Sicherheitsebene zu Ihrem Konto hinzu. Nach
          der Aktivierung benötigen Sie neben Ihrem Passwort auch einen zeitbasierten Code von Ihrer
          Authenticator-App.
        </p>

        <p style={{ margin: '8px 0 0', fontWeight: 500 }}>Geplante Funktionen:</p>
        <ul className="wc-muted" style={{ margin: 0, paddingLeft: 20 }}>
          <li>QR-Code Einrichtung mit Authenticator-Apps</li>
          <li>Backup-Codes für Notfälle</li>
          <li>Optionale Aktivierung/Deaktivierung</li>
          <li>Kompatibel mit Google Authenticator, Authy, etc.</li>
        </ul>
      </div>
    </div>
  )
}
